import React from 'react';
import { AccordionProvider } from './AccordionContext';
import './HeadlessAccordion.scss';
import Trigger, { Props as TriggerProps } from './Trigger';
import Panel, { Props as PanelProps } from './Panel';
import { AccordionContext } from './AccordionContext';
import { AccordionRootProps } from './AccordionRoot.types';

const Root = ({ children, ...props }: AccordionRootProps) => {
  return (
    <AccordionProvider>
      <div data-testid="headles-accordion-root-testid" className="accordion">
        <div {...props}>{children}</div>
      </div>
    </AccordionProvider>
  );
};

export const Accordion = Object.assign(
  {},
  {
    Root: Root,
    Trigger: Trigger,
    Panel: Panel,
    Context: AccordionContext,
  }
);

export type { TriggerProps, PanelProps };

export default Root;
